export default {
  GET_DESTINATION_COUNTRIES_BEGIN: 'tours/searchFrom/GET_DESTINATION_COUNTRIES',
  GET_DESTINATION_COUNTRIES_FAIL: 'tours/searchFrom/GET_DESTINATION_COUNTRIES_FAIL',
  GET_DESTINATION_COUNTRIES_SUCCESS: 'tours/searchFrom/GET_DESTINATION_COUNTRIES_SUCCESS',

  SET_DESTINATION_QUERY: 'tours/searchFrom/SET_DESTINATION_QUERY',
  SET_DESTINATION_SUGGESTIONS: 'tours/searchFrom/SET_DESTINATION_SUGGESTIONS',

  RESET_DESTINATION_SUGGESTIONS: 'tours/searchFrom/RESET_DESTINATION_SUGGESTIONS',

  GET_DESTINATION_SUGGESTIONS_BEGIN: 'tours/searchFrom/GET_DESTINATION_SUGGESTIONS',
  GET_DESTINATION_SUGGESTIONS_FAIL: 'tours/searchFrom/GET_DESTINATION_SUGGESTIONS_FAIL',
  GET_DESTINATION_SUGGESTIONS_SUCCESS: 'tours/searchFrom/GET_DESTINATION_SUGGESTIONS_SUCCESS',
};
